import React from 'react';
import Zmage from 'react-zmage';
import logo from './logo.svg';
import './App.css';
import { Divider, Table } from 'antd';
import 'antd/dist/antd.css';
import * as DataClass from './data';
import {
  Label,
  Legend,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ComposedChart,
  Bar,
} from 'recharts';

const CHART_WIDTH = 400;
const DOUBLE_AX_WIDTH = CHART_WIDTH;
const CHART_FONT_SIZE = 15;
const IMAGE_WIDTH = '100%';

const dataSource = [
  {
    key: '1',
    portal: 'https://i.loli.net/2020/06/08/UsaQbLZSgpz2NXY.png',
    demo1: 'https://i.loli.net/2020/06/08/sMoBZv8DNGnyOWX.png',
    demo2: 'https://i.loli.net/2020/06/08/7MyCbYSG2wRXzes.png',
  },
];

const columns = [
  {
    title: 'MLModelCI Web Portal',
    dataIndex: 'portal',
    key: 'portal',
    render: (e) => (
      <div>
        <Zmage alt="..." src={String(e)} width={IMAGE_WIDTH}></Zmage>
      </div>
    ),
  },
  {
    title: 'Application Demo (BERT) ',
    dataIndex: 'demo1',
    key: 'demo2',
    render: (e) => (
      <div>
        <Zmage alt="..." src={String(e)} width={IMAGE_WIDTH}></Zmage>
      </div>
    ),
  },
  {
    title: 'Application Demo (Mask R-CNN)',
    dataIndex: 'demo2',
    key: 'demo2',
    render: (e) => (
      <div>
        <Zmage alt="..." src={String(e)} width={IMAGE_WIDTH}></Zmage>
      </div>
    ),
  },
];

function App() {
  return (
    <div className="App">
      <img src={logo} width="160" alt="..." />
      <h1 align="center" style={{ marginTop: '15px', fontSize: 25 }}>
        MLModelCI: An Automatic Cloud Platform for Efficient MLaaS
      </h1>
      <p style={{ marginTop: '-10px' }}>
        Huaizheng Zhang, Yuanming Li, Yizheng Huang, Yonggang Wen, Jianxiong Yin
        <sup>+</sup>, Kyle Guan<sup>*</sup>
      </p>
      <p style={{ marginTop: '-8px' }}>
        Nanyang Technological University, Singapore; NVIDIA AI Tech Center
        <sup>+</sup>; Nokia Bell Labs<sup>*</sup>
      </p>
      <p align="center" style={{ marginTop: '15px' }}>
        <a href="https://github.com/cap-ntu/ML-Model-CI">Code</a> •&nbsp;
        <a href="https://github.com/cap-ntu/ML-Model-CI">Paper</a> •&nbsp;
        <a href="https://github.com/cap-ntu/ML-Model-CI#tutorial">Tutorial</a>
        •&nbsp;
        <a href="https://github.com/cap-ntu/ML-Model-CI">Slides</a> •&nbsp;
        <a href="https://github.com/cap-ntu/ML-Model-CI">Citation</a> •&nbsp;
        <a href="https://github.com/cap-ntu/ML-Model-CI">News</a>
      </p>
      <Divider orientation="left">Sample Profiling Results of ResNet50</Divider>
      <div style={{ display: 'flex' }}></div>
      <br />
      <div className="showDataClass">
        <ComposedChart
          width={DOUBLE_AX_WIDTH}
          height={CHART_WIDTH}
          data={DataClass.smsd_dbs_T4}
          margin={{
            top: 5,
            right: 20,
            left: 15,
            bottom: 50,
          }}
        >
          <Legend verticalAlign="top" height={36} />
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <XAxis dataKey="bs">
            <Label
              offset={-23}
              value="Batch Size"
              position="insideBottom"
              style={{ textAnchor: 'middle', fontSize: CHART_FONT_SIZE }}
            />
          </XAxis>
          <YAxis
            yAxisId="latency"
            orientation="right"
            type="number"
            domain={[0, 550]}
          >
            <Label
              value="95th Percentile Latency (ms)"
              position="insideRight"
              angle={-90}
              style={{ textAnchor: 'middle', fontSize: CHART_FONT_SIZE }}
            />
          </YAxis>
          <YAxis
            yAxisId="throughput"
            orientation="left"
            type="number"
            domain={[0, 320]}
          >
            <Label
              value="Throughput on Tesla T4 (req/sec)"
              position="insideLeft"
              angle={-90}
              style={{ textAnchor: 'middle', fontSize: CHART_FONT_SIZE }}
            />
          </YAxis>
          <Tooltip />
          <Bar
            dataKey="throughput"
            barSize={25}
            fill="#4169E1"
            yAxisId="throughput"
          />
          <Line
            strokeWidth={2}
            type="monotone"
            dataKey="latency"
            stroke="#ff7300"
            yAxisId="latency"
          />
        </ComposedChart>
        <ComposedChart
          width={DOUBLE_AX_WIDTH}
          height={CHART_WIDTH}
          data={DataClass.same_device_diff_gpu}
          margin={{
            top: 5,
            right: 20,
            left: 15,
            bottom: 50,
          }}
        >
          <Legend verticalAlign="top" height={36} />
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <XAxis dataKey="gpu">
            <Label
              offset={-23}
              value="Serving Device"
              position="insideBottom"
              style={{ textAnchor: 'middle', fontSize: CHART_FONT_SIZE }}
            />
          </XAxis>
          <YAxis
            yAxisId="latency"
            orientation="right"
            type="number"
            domain={[0, 100]}
          >
            <Label
              value="95th Percentile Latency (ms)"
              position="insideRight"
              angle={-90}
              style={{ textAnchor: 'middle', fontSize: CHART_FONT_SIZE }}
            />
          </YAxis>
          <YAxis
            yAxisId="throughput"
            orientation="left"
            type="number"
            domain={[0, 600]}
          >
            <Label
              value="Throughput for Batch Size 16 (req/sec)"
              position="insideLeft"
              angle={-90}
              style={{ textAnchor: 'middle', fontSize: CHART_FONT_SIZE }}
            />
          </YAxis>
          <Tooltip />
          <Bar
            dataKey="throughput"
            barSize={25}
            fill="#20B2AA"
            yAxisId="throughput"
          />
          <Bar
            dataKey="latency"
            barSize={25}
            fill="#EEAD0E"
            yAxisId="latency"
          />
        </ComposedChart>
      </div>
      <div className="showDataClass">
        <ComposedChart
          width={CHART_WIDTH}
          height={CHART_WIDTH}
          data={DataClass.dp_throughput_bs2}
          margin={{
            top: 5,
            right: 15,
            left: 15,
            bottom: 50,
          }}
        >
          <Legend verticalAlign="top" height={36} />
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <XAxis dataKey="platform">
            <Label
              offset={-23}
              value="Serving Platform"
              position="insideBottom"
              style={{ textAnchor: 'middle', fontSize: CHART_FONT_SIZE }}
            />
          </XAxis>
          <YAxis orientation="left" type="number" domain={[0, 220]}>
            <Label
              value="Throughput (req/sec)"
              position="insideLeft"
              angle={-90}
              style={{ textAnchor: 'middle', fontSize: CHART_FONT_SIZE }}
            />
          </YAxis>
          <Tooltip />
          <Bar dataKey="T4" barSize={25} fill="#4169E1" />
          <Bar dataKey="P4" barSize={25} fill="#3CB371" />
        </ComposedChart>
        <ComposedChart
          width={CHART_WIDTH}
          height={CHART_WIDTH}
          data={DataClass.dp_util_T4}
          margin={{
            top: 5,
            right: 15,
            left: 15,
            bottom: 50,
          }}
        >
          <Legend verticalAlign="top" height={36} />
          <Line
            type="monotone"
            dataKey="TensorFlow"
            stroke="#ff7300"
            strokeWidth={1.5}
          />
          <Line
            type="monotone"
            dataKey="TorchScript"
            stroke="#3CB371"
            strokeWidth={1.5}
          />
          <Line
            type="monotone"
            dataKey="TensorRT"
            stroke="#CD1076"
            strokeWidth={1.5}
          />
          <Line
            type="monotone"
            dataKey="ONNX"
            stroke="#FFD700"
            strokeWidth={1.5}
          />
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <XAxis dataKey="bs">
            <Label
              offset={-23}
              value="Batch Size"
              position="insideBottom"
              style={{ textAnchor: 'middle', fontSize: CHART_FONT_SIZE }}
            />
          </XAxis>
          <YAxis type="number" domain={[0, 100]}>
            <Label
              value="Average GPU Utilization (%)"
              position="insideLeft"
              angle={-90}
              style={{ textAnchor: 'middle', fontSize: CHART_FONT_SIZE }}
            />
          </YAxis>
          <Tooltip />
        </ComposedChart>
      </div>
      <Divider orientation="left">Click to Check the Large Image</Divider>
      <div
        style={{
          width: '100%',
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Table
          style={{ width: '95%' }}
          dataSource={dataSource}
          columns={columns}
        />
      </div>
      <br />
    </div>
  );
}

export default App;
